import React from 'react';
import ReactDOM from 'react-dom/client';
import './Style.scss';
import StandardHub from './StandardHub';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <StandardHub />
  </React.StrictMode>
);
